import type { InputHTMLAttributes } from 'react'

interface CustomTextInputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string
  error?: string
}

export function CustomTextInput({
  label,
  error,
  className = '',
  id,
  ...props
}: CustomTextInputProps) {
  const inputId = id || label?.toLowerCase().replace(/\s+/g, '-')

  return (
    <div className="flex flex-col gap-1">
      {label && (
        <label htmlFor={inputId} className="text-sm font-medium text-gray-700 dark:text-gray-300">
          {label}
        </label>
      )}
      <input
        id={inputId}
        className={`rounded-xl border border-gray-300 dark:border-[#3d2c4f] bg-white dark:bg-[#1a1520] text-gray-900 dark:text-gray-100 px-4 py-2.5 text-base transition-all duration-200 focus:border-[#503864] dark:focus:border-[#7f4f9a] focus:outline-none focus:ring-2 focus:ring-[#503864]/20 dark:focus:ring-[#7f4f9a]/20 placeholder:text-gray-400 dark:placeholder:text-gray-500 ${
          error ? 'border-red-500 dark:border-red-400' : ''
        } ${className}`}
        {...props}
      />
      {error && <span className="text-sm text-red-500 dark:text-red-400">{error}</span>}
    </div>
  )
}
